import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { BEFE_KEYS, apiUrls } from "../../constants/apiUrls";

export const getCommonConfig = async () => {
  const apiPayload = {
    method: "GET",
    url:
      Env.getBefeBaseUrl() + BEFE_KEYS.commonConfig + Env.getbefeEnvPostFix(),
  };

  return handlePromise(apiPayload);
};

export const updateToolTip = async (postData) => {
  const apiPayload = {
    method: "POST",
    data:postData,
    url:
      Env.getLcoBasePath() + apiUrls.updateToolTip,
  };

  return handlePromise(apiPayload);
};
